import React from 'react';
import { ArrowLeft, Bell, Calendar, Tag, Info } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useStore, markNotificationRead, markAllNotificationsRead } from '../lib/store';
export function Notifications() {
  const navigate = useNavigate();
  const {
    notifications
  } = useStore();
  const getIcon = (type: string) => {
    switch (type) {
      case 'reminder':
        return <Calendar size={20} className="text-blue-400" data-id="element-966" />;
      case 'promo':
        return <Tag size={20} className="text-gold" data-id="element-967" />;
      default:
        return <Info size={20} className="text-light-muted" data-id="element-968" />;
    }
  };
  return <div className="min-h-screen bg-dark flex flex-col" data-id="element-969">
      <header className="p-6 flex items-center justify-between border-b border-white/5" data-id="element-970">
        <div className="flex items-center gap-4" data-id="element-971">
          <button onClick={() => navigate(-1)} className="text-light hover:text-gold" data-id="element-972">
            <ArrowLeft size={24} data-id="element-973" />
          </button>
          <h2 className="text-lg font-medium text-light" data-id="element-974">Notificaciones</h2>
        </div>
        <button onClick={markAllNotificationsRead} className="text-xs text-gold" data-id="element-975">
          Marcar leídas
        </button>
      </header>
      <div className="flex-1 overflow-y-auto p-6 space-y-4" data-id="element-976">
        {notifications.length === 0 ? <div className="text-center py-12 text-light-muted" data-id="element-977">
            <Bell size={48} className="mx-auto mb-4 opacity-20" data-id="element-978" />
            <p data-id="element-979">No tenés notificaciones.</p>
          </div> : notifications.map(n => <div key={n.id} onClick={() => markNotificationRead(n.id)} className={`p-4 rounded-2xl border transition-colors flex gap-4 cursor-pointer ${n.read ? 'bg-dark-card border-white/5 opacity-70' : 'bg-dark-card border-gold/30'}`} data-id="element-980">
              <div className="w-10 h-10 rounded-full bg-dark flex items-center justify-center flex-shrink-0 border border-white/5" data-id="element-981">
                {getIcon(n.type)}
              </div>
              <div data-id="element-982">
                <h4 className="text-sm font-medium text-light mb-1" data-id="element-983">
                  {n.title}
                </h4>
                <p className="text-xs text-light-muted mb-2" data-id="element-984">{n.body}</p>
                <span className="text-[10px] text-light-muted/50" data-id="element-985">
                  {n.date}
                </span>
              </div>
            </div>)}
      </div>
    </div>;
}